<template>
  <!-- 新增计划/组合弹窗 -->
  <Modal
    :visible="showModal"
    :title="$t('R3003')"
    title-align="start"
    :unmount-on-close="true"
    modal-class="coros-training-edit-modal training-modal"
    @cancel="handleCancel"
  >
    <div>
      <!-- 训练类型 -->
      <div class="flex flex-row justify-start items-center">
        <!-- 左侧 -->
        <div class="flex-1">
          <Form
            layout="vertical"
            :model="{}"
          >
            <FormItem :label="`${$t('R6001')} ${$t('R1013')}`">
              <Select
                :model-value="trainingProgram.sportType"
                :disabled="readonly"
                class="program-edit-input w-320"
                @update:model-value="changeSportCategory"
              >
                <template #label="{ data: selectOptionData }">
                  <div class="flex flex-row justify-start">
                    <span
                      class="program-edit-option-icon mr-8 iconfont"
                      :class="[sportCategoryConfigMap[selectOptionData.value].icon]"
                      :style="{
                        color: sportCategoryConfigMap[selectOptionData.value].color,
                        'text-fill-color': sportCategoryConfigMap[selectOptionData.value].color
                      }"
                    ></span>
                    <span>{{ $t(sportCategoryConfigMap[selectOptionData.value].label) }}</span>
                  </div>
                </template>
                <Option
                  v-for="(item, index) in sportTypeOptions"
                  :key="index"
                  :value="item.type"
                >
                  <div class="flex flex-row justify-start">
                    <span
                      class="program-edit-option-icon mr-8"
                      :style="{ color: item.color }"
                      :class="item.icon"
                    ></span>
                    <span>{{ $t(item.label) }}</span>
                  </div>
                </Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('R6002')">
              <Input
                :model-value="$t(trainingProgram.name)"
                :disabled="readonly"
                :max-length="90"
                :word-length="getStringByte"
                :word-slice="getStringByMaxBytes"
                @input="handleNameInputChange"
                class="w-320"
              />
            </FormItem>

            <SwimPoolLength
              :sport-type="trainingProgram.sportType"
              :readonly="readonly"
              class="w-320"
            />
          </Form>
        </div>
        <!-- 右侧 -->
        <div class="flex-1">
          <Form
            layout="vertical"
            :model="{}"
          >
            <FormItem :label="$t('R1011')">
              <Textarea
                :model-value="$t(trainingProgram.overview)"
                @input="handleOverviewInputChange"
                :disabled="readonly"
                :row="5"
                :max-length="200"
                :show-word-limit="true"
                class="coros-training-edit-textarea"
                :placeholder="$t('R1012')"
              ></Textarea>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
    <Divider class="border-border-1"></Divider>
    <div>
      <Form
        layout="vertical"
        :model="{}"
      >
        <!-- 目标类型 -->
        <FormItem
          :label="$t('R6003')"
          class="plan-edit-target training-sub-item"
        >
          <div class="flex flex-row justify-start">
            <Select
              v-model="exercise.targetTypeName"
              :disabled="readonly || (trainingProgram.sportType === 3 && exercise.intensityCount?.swimmingStyle?.type === 6)"
              class="program-target-select mr-16 w-120"
              @change="handleTargetTypeChange"
            >
              <Option
                v-for="(item, index) in targetOptions"
                :key="index"
                :value="item.key"
                :label="item.nameText"
              >
              </Option>
            </Select>
            <template v-if="exercise.targetTypeName === 'time'">
              <TimePicker
                class="program-time-inputgroup"
                v-model="exercise.targetCount.time.valueText"
                :disabled="readonly"
                format="HH:mm:ss"
                :allow-clear="false"
                disableConfirm
                @change="handleTimeChange"
              >
                <template #suffix-icon>
                  <span class="color-gray-500">h:m:s</span>
                </template>
              </TimePicker>
            </template>
            <template v-if="exercise.targetTypeName === 'distance'">
              <InputGroup class="w-180 bg-input border border-border-3 rounded-sm">
                <!-- 游泳专用，只提供选择，不自由输入，选项根据当前的泳池长度来决定 -->
                <Select
                  v-if="trainingProgram.sportType === 3 && distanceOptions.length"
                  v-model="exercise.targetCount.distance.value"
                  class="w-160"
                  :disabled="readonly"
                  :format-label="(data) => `${data.labelForDisplay}`"
                  :options="distanceOptions"
                  :virtual-list-props="{ height: 200 }"
                  :trigger-props="{ autoFitPopupMinWidth: true }"
                />
                <InputNumberFixed
                  v-if="trainingProgram.sportType !== 3"
                  v-model="exercise.targetCount.distance.value"
                  :disabled="readonly"
                  :precision="exerciseTargetConfig.inputConfig.precision"
                  :min="exerciseTargetConfig.inputConfig.min"
                  :max="exerciseTargetConfig.inputConfig.max"
                  :step="exerciseTargetConfig.inputConfig.step"
                  class="noborder border-r border-border-1"
                />
                <span
                  v-if="trainingProgram.sportType === 3"
                  class="unit-append border-l w-80 text-center border-none"
                  >{{ poolLengthUnit === 2 ? 'm' : 'yd' }}</span
                >
                <Select
                  v-if="trainingProgram.sportType !== 3"
                  :model-value="exercise.targetCount.distance.unit"
                  :disabled="readonly"
                  @change="changeTargetDistanceUnit"
                  class="unit-append border-l w-80 noborder"
                >
                  <Option
                    v-for="(item, index) in unitOptions"
                    :key="index"
                    :value="item.key"
                    :label="item.nameText"
                  >
                  </Option>
                </Select>
              </InputGroup>
            </template>
            <template v-if="exercise.targetTypeName === 'load'">
              <InputGroup class="border-border-3 border rounded-sm w-120 bg-input">
                <InputNumberFixed
                  v-model="exercise.targetCount.load.value"
                  :disabled="readonly"
                  :precision="exerciseTargetConfig.inputConfig.precision"
                  :min="exerciseTargetConfig.inputConfig.min"
                  :max="exerciseTargetConfig.inputConfig.max"
                  :step="exerciseTargetConfig.inputConfig.step"
                  hide-button
                  class="noborder"
                >
                  <template #suffix>
                    <span class="color-gray-500 px-10 border-l border-border-1">TL</span>
                  </template>
                </InputNumberFixed>
              </InputGroup>
            </template>
            <template v-if="exercise.targetTypeName === 'cumulativeClimb'">
              <InputGroup class="border-border-1 border rounded-sm w-140">
                <InputNumberFixed
                  v-model="exercise.targetCount.cumulativeClimb.value"
                  :disabled="readonly"
                  :precision="exerciseTargetConfig.inputConfig.precision"
                  :min="exerciseTargetConfig.inputConfig.min"
                  :max="exerciseTargetConfig.inputConfig.max"
                  :step="exerciseTargetConfig.inputConfig.step"
                  hide-button
                  class="border-border-1 border-r"
                >
                </InputNumberFixed>
                <Select
                  :model-value="exercise.targetCount.cumulativeClimb.unit"
                  :disabled="readonly"
                  @change="changeTargetDistanceUnit"
                  class="w-80"
                >
                  <Option
                    v-for="(item, index) in unitOptions"
                    :key="index"
                    :value="item.key"
                    :label="item.nameText"
                  >
                  </Option>
                </Select>
              </InputGroup>
            </template>
            <template v-if="exercise.targetTypeName === 'heartRateRecovery'">
              <InputGroup class="border-border-1 border rounded-sm w-120 bg-input">
                <InputNumberFixed
                  v-model="exercise.targetCount.heartRateRecovery.value"
                  :disabled="readonly"
                  :precision="exerciseTargetConfig.inputConfig.precision"
                  :min="exerciseTargetConfig.inputConfig.min"
                  :max="exerciseTargetConfig.inputConfig.max"
                  :step="exerciseTargetConfig.inputConfig.step"
                  hide-button
                >
                  <template #suffix>
                    <span class="color-gray-500 border-l border-dark-700 px-10">bpm</span>
                  </template>
                </InputNumberFixed>
              </InputGroup>
            </template>
            <!-- 目标值（线路）-->
            <template v-if="exercise.targetTypeName === 'routes'">
              <InputNumberFixed
                v-model="exercise.targetCount.routes.value"
                class="w-80 border-dark-60 border rounded-sm"
                :disabled="readonly"
                :min="exerciseTargetConfig.inputConfig.min"
                :max="exerciseTargetConfig.inputConfig.max"
                :step="exerciseTargetConfig.inputConfig.step"
                :precision="exerciseTargetConfig.inputConfig.precision"
              />
            </template>
          </div>
        </FormItem>
        <!-- 强度类型 -->
        <FormItem
          v-if="intensityOptions.length && exercise.targetTypeName !== 'heartRateRecovery'"
          :label="trainingProgram.sportType === 3 ? $t('S4113') : $t('R6007')"
          :data-type="intensityTypeConfig.type"
          class="plan-edit-intensity training-sub-item"
        >
          <!-- 强度类型选项 -->
          <Select
            v-if="trainingProgram.sportType !== 3 && !isIndoorClimbOrBoulderingTrainingSportType(trainingProgram.sportType)"
            v-model="exercise.intensityTypeName"
            :disabled="readonly"
            class="program-distance-inputgroup mr-10 border-dark-60"
            :trigger-props="{ autoFitPopupMinWidth: true }"
            @change="handleIntensityTypeChange"
          >
            <template
              v-for="(item, index) in intensityOptions"
              :key="index"
            >
              <template v-if="item.children">
                <Option
                  v-for="(item1, index1) in item.children"
                  :key="index1"
                  :value="item1.key"
                  :label="item1.nameText"
                >
                </Option>
              </template>
              <!-- 不设置 -->
              <template v-else>
                <Divider :margin="1"></Divider>
                <Option
                  :value="item.key"
                  :label="item.nameText"
                >
                </Option>
              </template>
            </template>
          </Select>
          <!-- 根据条件切换可选项 -->
          <!-- <template v-if="intensityTypeConfig.extendType === 'weight'"> </template> -->

          <!-- 强度值--心率 -->
          <template v-if="intensityTypeConfig.extendType === 'heart'">
            <!-- 心率百分比 -->
            <template v-if="exercise.isIntensityPercent">
              <!-- 区间选择 -->
              <Select
                class="program-distance-inputgroup mr-10"
                @change="changeZone"
                v-model="exercise.intensityCount[exercise.intensityTypeName].type"
                :disabled="readonly"
              >
                <Option
                  v-for="(item, index) in heartIntensityZoneList"
                  :key="index"
                  :value="item.type"
                  :label="item.nameText"
                >
                </Option>
              </Select>
              <!-- 范围值 -->
              <div class="plan-edit-range-input flex flex-row justify-start items-center">
                <!-- 范围输入框 -->
                <!-- 已登录的或者自定义区间才显示对应的范围 -->
                <template v-if="userId || exercise.intensityCount[exercise.intensityTypeName].type === 0">
                  <div
                    v-if="!isLastZone && !isFirstZone"
                    class="rounded-sm plan-input-number-range border-border-1 border w-160"
                  >
                    <InputNumberRange
                      :model-value="exercise.intensityCount[exercise.intensityTypeName].ratioRange"
                      :disabled="readonly"
                      :min="exerciseIntensityConfig.ratioRangeConfig.min"
                      :max="exerciseIntensityConfig.ratioRangeConfig.max"
                      :step="exerciseIntensityConfig.ratioRangeConfig.step"
                      :precision="exerciseIntensityConfig.ratioRangeConfig.precision"
                      hide-button
                      @change="changeHrRatioRange"
                    >
                      <template #suffix>
                        <span class="px-10">%</span>
                      </template>
                    </InputNumberRange>
                  </div>
                  <div
                    v-else-if="isFirstZone"
                    class="text-text-3 last-zone-value"
                  >
                    <Input
                      class="program-distance-input-suffix text-white"
                      disabled
                      v-model="exercise.intensityCount[exercise.intensityTypeName].ratioRange[1]"
                    >
                      <template #prefix>
                        <span>{{ $t('G3024') }}</span>
                      </template>
                      <template #suffix>
                        <span>%</span>
                      </template>
                    </Input>
                  </div>
                  <div
                    v-else
                    class="last-zone-value"
                  >
                    <Input
                      class="text-white last-zone-value"
                      disabled
                      :input-attrs="{
                        size: exercise.intensityCount[exercise.intensityTypeName].ratioRange[0].toString().length
                      }"
                      :model-value="exercise.intensityCount[exercise.intensityTypeName].ratioRange[0]"
                    >
                      <template #prefix>
                        <span>{{ $t('G3023') }}</span>
                      </template>
                      <template #suffix>
                        <span>%</span>
                      </template>
                    </Input>
                  </div>
                </template>
                <!-- 范围值提示 -->
                <!-- 已登录的或者自定义区间才显示对应的范围 -->
                <template v-if="userId || exercise.intensityCount[exercise.intensityTypeName].type === 0">
                  <div class="flex flex-row justify-start text-text-3">
                    <template v-if="!isLastZone && !isFirstZone">
                      <span class="program-distance-input-label text-center">{{
                        exercise.intensityCount[exercise.intensityTypeName].range[0]
                      }}</span>
                      <span class="count-symbol">-</span>
                      <span class="program-distance-input-label text-center">{{
                        exercise.intensityCount[exercise.intensityTypeName].range[1]
                      }}</span>
                    </template>
                    <div
                      v-else-if="isFirstZone"
                      class="text-center pl-10"
                    >
                      <span> {{ $t('G3024') }}</span>
                      <span>{{ exercise.intensityCount[exercise.intensityTypeName].range[1] }}</span>
                    </div>
                    <div
                      v-else
                      class="text-center pl-10"
                    >
                      <span> {{ $t('G3023') }}</span>
                      <span>{{ exercise.intensityCount[exercise.intensityTypeName].range[0] }}</span>
                    </div>
                  </div>
                  <span class="text-text-3 ml-10">bpm</span>
                </template>
              </div>
            </template>
            <!-- 心率值 -->
            <template v-else>
              <div>
                <div class="border-border-3 border rounded-sm w-180">
                  <InputNumberRange
                    :model-value="exercise.intensityCount[exercise.intensityTypeName].range"
                    :min="exerciseIntensityConfig.rangeConfig.min"
                    :max="exerciseIntensityConfig.rangeConfig.max"
                    :step="exerciseIntensityConfig.rangeConfig.step"
                    :precision="exerciseIntensityConfig.rangeConfig.precision"
                    :disabled="readonly"
                    hide-button
                    @change="changeHrRange"
                  >
                    <!-- TODO  change ratio -->
                    <template #suffix>
                      <span class="text-text-3 px-10">bpm</span>
                    </template>
                  </InputNumberRange>
                </div>
              </div>
            </template>
          </template>

          <!-- 强度值--ftp-->
          <template v-if="intensityTypeConfig.extendType === 'ftp'">
            <!-- 区间选择 -->
            <Select
              class="program-distance-inputgroup mr-10"
              @change="changeZone"
              v-model="exercise.intensityCount[exercise.intensityTypeName].type"
              :disabled="readonly"
            >
              <Option
                v-for="(item, index) in ftpIntensityZoneList"
                :key="index"
                :value="item.type"
                :label="item.nameText"
              >
              </Option>
              <Option :value="0">{{ $t('S4238') }}</Option>
            </Select>
            <!-- 范围值 -->
            <div class="plan-edit-range-input flex flex-row justify-start items-center">
              <!-- 范围输入框 -->
              <template v-if="userId">
                <div
                  v-if="!isLastZone && !isFirstZone"
                  class="rounded-sm plan-input-number-range border-border-1 border w-160"
                >
                  <InputNumberRange
                    :model-value="exercise.intensityCount[exercise.intensityTypeName].ratioRange"
                    :disabled="readonly"
                    :min="exerciseIntensityConfig.ratioRangeConfig.min"
                    :max="exerciseIntensityConfig.ratioRangeConfig.max"
                    :step="exerciseIntensityConfig.ratioRangeConfig.step"
                    :precision="exerciseIntensityConfig.ratioRangeConfig.precision"
                    hide-button
                    @change="changeFtpRatioRange"
                  >
                    <template #suffix>
                      <span class="px-10">%</span>
                    </template>
                  </InputNumberRange>
                </div>
                <div
                  v-else-if="isFirstZone"
                  class="text-text-3 last-zone-value"
                >
                  <Input
                    class="program-distance-input-suffix text-white"
                    disabled
                    v-model="exercise.intensityCount[exercise.intensityTypeName].ratioRange[1]"
                  >
                    <template #prefix>
                      <span>{{ $t('G3024') }}</span>
                    </template>
                    <template #suffix>
                      <span>%</span>
                    </template>
                  </Input>
                </div>
                <div
                  v-else
                  class="last-zone-value"
                >
                  <Input
                    class="text-white last-zone-value"
                    disabled
                    :input-attrs="{
                      size: exercise.intensityCount[exercise.intensityTypeName].ratioRange[0].toString().length
                    }"
                    :model-value="exercise.intensityCount[exercise.intensityTypeName].ratioRange[0]"
                  >
                    <template #prefix>
                      <span>{{ $t('G3023') }}</span>
                    </template>
                    <template #suffix>
                      <span>%</span>
                    </template>
                  </Input>
                </div>
              </template>
              <!-- 范围值提示 -->
              <div class="flex flex-row justify-start text-text-3">
                <template v-if="!isLastZone && !isFirstZone">
                  <span class="program-distance-input-label text-center">{{
                    exercise.intensityCount[exercise.intensityTypeName].range[0]
                  }}</span>
                  <span class="count-symbol">-</span>
                  <span class="program-distance-input-label text-center">{{
                    exercise.intensityCount[exercise.intensityTypeName].range[1]
                  }}</span>
                </template>
                <div
                  v-else-if="isFirstZone"
                  class="text-center pl-10"
                >
                  <span> {{ $t('G3024') }}</span>
                  <span>{{ exercise.intensityCount[exercise.intensityTypeName].range[1] }}</span>
                </div>
                <div
                  v-else
                  class="text-center pl-10"
                >
                  <span> {{ $t('G3023') }}</span>
                  <span>{{ exercise.intensityCount[exercise.intensityTypeName].range[0] }}</span>
                </div>
              </div>
              <span class="text-text-3 ml-10">w</span>
            </div>
          </template>

          <!-- 强度值--配速类 -->
          <template v-if="intensityTypeConfig.extendType === 'pace'">
            <!-- 百分比 -->
            <template v-if="exercise.isIntensityPercent">
              <!-- 区间选择 -->
              <Select
                class="program-distance-inputgroup mr-10"
                @change="changeZone"
                v-model="exercise.intensityCount[exercise.intensityTypeName].type"
                :disabled="readonly"
              >
                <Option
                  v-for="(item, index) in paceIntensityZoneList"
                  :key="index"
                  :value="item.type"
                  :label="item.nameText"
                >
                </Option>
              </Select>
              <!-- 范围值 -->
              <!-- 已登录的或者自定义区间才显示对应的范围 -->
              <template v-if="userId || exercise.intensityCount[exercise.intensityTypeName].type === 0">
                <div class="plan-edit-range-input flex flex-row justify-start items-center">
                  <template v-if="!isLastZone && !isFirstZone">
                    <div class="border-border-3 border rounded-sm w-180">
                      <InputNumberRange
                        :model-value="exercise.intensityCount[exercise.intensityTypeName].ratioRange"
                        :disabled="readonly"
                        :min="exerciseIntensityConfig.ratioRangeConfig.min"
                        :max="exerciseIntensityConfig.ratioRangeConfig.max"
                        :step="exerciseIntensityConfig.ratioRangeConfig.step"
                        :precision="exerciseIntensityConfig.ratioRangeConfig.precision"
                        hide-button
                        @change="changePaceRatioRange"
                      >
                        <template #suffix>
                          <span class="px-10">%</span>
                        </template>
                      </InputNumberRange>
                    </div>
                  </template>
                  <!-- 第一个值 -->
                  <div
                    v-else-if="isFirstZone"
                    class="bg-dark-500 border-border-1 flex flex-row justify-start items-center text-text-3 border rounded-sm"
                  >
                    <Input
                      class="program-distance-input-suffix text-white last-zone-value"
                      disabled
                      v-model="exercise.intensityCount[exercise.intensityTypeName].ratioRange[1]"
                    >
                      <template #prefix>
                        <span>{{ $t('G3067') }}</span>
                      </template>
                      <template #suffix>
                        <span>%</span>
                      </template>
                    </Input>
                  </div>
                  <div
                    v-else
                    class="bg-dark-500 text-text-3"
                  >
                    <Input
                      class="program-distance-input-suffix text-white last-zone-value"
                      disabled
                      v-model="exercise.intensityCount[exercise.intensityTypeName].ratioRange[0]"
                    >
                      <template #prefix>
                        <span>{{ $t('G3066') }}</span>
                      </template>
                      <template #suffix>
                        <span>%</span>
                      </template>
                    </Input>
                  </div>
                  <!-- 提示 -->
                  <div class="flex flex-row justify-start text-text-3 ml-10">
                    <template v-if="!isLastZone && !isFirstZone">
                      <span class="program-distance-input-label text-center">{{
                        s2ms(exercise.intensityCount[exercise.intensityTypeName].range[1])
                      }}</span>
                      <span class="count-symbol">-</span>
                      <span class="program-distance-input-label text-center">{{
                        s2ms(exercise.intensityCount[exercise.intensityTypeName].range[0])
                      }}</span>
                    </template>
                    <div
                      v-else-if="isFirstZone"
                      class="text-center pl-10"
                    >
                      <span> {{ $t('G3024') }}</span>
                      <span>{{ s2ms(exercise.intensityCount[exercise.intensityTypeName].range[1]) }}</span>
                    </div>
                    <div
                      v-else
                      class="text-center pl-10"
                    >
                      <span> {{ $t('G3023') }}</span>
                      <span>{{ s2ms(exercise.intensityCount[exercise.intensityTypeName].range[0]) }}</span>
                    </div>
                  </div>
                  <span class="ml-10 text-text-3">{{ exercise.intensityCount[exercise.intensityTypeName].unit }}</span>
                </div>
              </template>
            </template>
            <!-- 绝对值 -->
            <template v-else>
              <div class="plan-edit-range-input flex flex-row justify-start items-center border border-border-3 rounded-sm">
                <!-- 配速单位为s/100m时，使用数字范围组件 -->
                <template v-if="exercise.intensityCount[exercise.intensityTypeName].unit === 's/100m'">
                  <div class="w-160">
                    <!-- TODO 更新组件，支持数字范围组件 -->
                    <InputNumberRange
                      :model-value="exercise.intensityCount[exercise.intensityTypeName].range"
                      @change="changeSpeedRange"
                      class="border-0"
                      hide-button
                      :disabled="readonly"
                      :min="exerciseIntensityConfig.rangeConfig.min"
                      :max="exerciseIntensityConfig.rangeConfig.max"
                      :step="exerciseIntensityConfig.rangeConfig.step"
                      :precision="exerciseIntensityConfig.rangeConfig.precision"
                    >
                    </InputNumberRange>
                  </div>
                </template>
                <!-- 配速单位不是s/100m时，使用分秒范围组件 -->
                <template v-else>
                  <TimePicker
                    class="no-focus w-160 border-none rounded-0"
                    type="time-range"
                    :disabled="readonly"
                    :format="paceFormat"
                    :default-value="exercise.intensityCount[exercise.intensityTypeName].range.map(s2ms)"
                    :allow-clear="false"
                    disableConfirm
                    @change="changePaceRange"
                  >
                    <template #suffix-icon>
                      <span></span>
                    </template>
                  </TimePicker>
                </template>
                <!-- 单位选择 -->
                <Select
                  v-model="exercise.intensityCount[exercise.intensityTypeName].unit"
                  :disabled="readonly"
                  class="select-pace-unit flex text-text-3 rounded-0 w-100 h-[32px] border-none"
                  @change="changeIntensityPaceUnit"
                >
                  <Option
                    v-for="(item, index) in intensityUnitOptions"
                    :key="index"
                    :value="item.key"
                    :label="item.nameText"
                  >
                  </Option>
                </Select>
              </div>
            </template>
          </template>
          <!-- 强度值--速度 -->
          <template v-if="intensityTypeConfig.extendType === 'speed'">
            <div class="plan-edit-range-input flex flex-row justify-start items-center">
              <InputGroup class="border border-border-3 rounded-sm">
                <InputNumberRange
                  input-class="text-center"
                  class="noborder border-r border-border-1 w-[140px]"
                  :model-value="exercise.intensityCount[exercise.intensityTypeName].range"
                  @change="changeSpeedRange"
                  hide-button
                  :min="exerciseIntensityConfig.rangeConfig.min"
                  :max="exerciseIntensityConfig.rangeConfig.max"
                  :step="exerciseIntensityConfig.rangeConfig.step"
                  :precision="exerciseIntensityConfig.rangeConfig.precision"
                  :disabled="readonly"
                ></InputNumberRange>
                <!-- 单位选择 -->
                <Select
                  :default-value="exercise.intensityCount[exercise.intensityTypeName].unit"
                  :disabled="readonly"
                  class="select-speed-unit noborder text-text-3 w-auto"
                  @change="changeIntensitySpeedUnit"
                >
                  <Option
                    v-for="(item, index) in intensityUnitOptions"
                    :key="index"
                    :value="item.key"
                    :label="item.nameText"
                  >
                  </Option>
                </Select>
              </InputGroup>
            </div>
          </template>
          <!-- 强度值--游泳 泳姿 -->
          <template v-if="intensityTypeConfig.extendType === 'swimmingStyle'">
            <Select
              class="program-distance-inputgroup mr-10 w-160"
              @change="
                (val) => {
                  changeZone(val);
                  changeSwimmingStyle(val);
                }
              "
              v-model="exercise.intensityCount[exercise.intensityTypeName].type"
              :disabled="readonly"
              :trigger-props="{ autoFitPopupMinWidth: true }"
            >
              <template #label="{ data }">
                <span>
                  {{
                    data?.value === 0
                      ? swimmingZoneList.find((item) => item.type === data?.value)?.nameText
                      : data?.value
                        ? swimmingZoneList.find((item) => item.type === data?.value)?.name2Text || data.label
                        : ''
                  }}</span
                >
              </template>
              <Option
                v-for="(item, index) in swimmingZoneList"
                :key="index"
                :value="item.type"
                :label="item.nameText"
              >
              </Option>
            </Select>
            <!-- </div> -->
          </template>
          <!-- 强度值--功率 -->
          <template v-if="intensityTypeConfig.extendType === 'power'">
            <!-- 骑行类型下功率不能下拉选择 -->
            <div v-if="currentCriticalPower && trainingProgram.sportType !== 2">
              <Select
                class="program-distance-inputgroup mr-10"
                @change="changeZone"
                v-model="exercise.intensityCount[exercise.intensityTypeName].type"
                :disabled="readonly"
              >
                <Option
                  v-for="(item, index) in powerIntensityZoneList"
                  :key="index"
                  :value="item.type"
                  :label="item.nameText"
                >
                </Option>
              </Select>
            </div>
            <div class="plan-edit-range-input flex flex-row justify-start items-center">
              <div class="border border-border-3 rounded-sm w-180">
                <InputNumberRange
                  :model-value="exercise.intensityCount[exercise.intensityTypeName].range"
                  :disabled="readonly"
                  :min="exerciseIntensityConfig.rangeConfig.min"
                  :max="exerciseIntensityConfig.rangeConfig.max"
                  :step="exerciseIntensityConfig.rangeConfig.step"
                  :precision="exerciseIntensityConfig.rangeConfig.precision"
                  @change="changePowerRange"
                ></InputNumberRange>
              </div>
            </div>
          </template>
          <!-- 强度值--步频 -->
          <template v-if="intensityTypeConfig.extendType === 'cadence'">
            <div class="plan-edit-range-input flex flex-row justify-start items-center">
              <div class="border border-border-3 w-180 rounded-sm">
                <InputNumberRange
                  :model-value="exercise.intensityCount[exercise.intensityTypeName].range"
                  :disabled="readonly"
                  :min="exerciseIntensityConfig.rangeConfig.min"
                  :max="exerciseIntensityConfig.rangeConfig.max"
                  :step="exerciseIntensityConfig.rangeConfig.step"
                  :precision="exerciseIntensityConfig.rangeConfig.precision"
                  @change="changeCadenceRange"
                ></InputNumberRange>
              </div>
            </div>
          </template>
          <!-- 强度值-难度 -->
          <template v-if="intensityTypeConfig.extendType === 'gradeSystem'">
            <div class="grouped-input rounded-sm">
              <Select
                :model-value="exercise.intensityCount[exercise.intensityTypeName].type"
                @update:model-value="changeGradeSystem"
                class="pl-10 intensity-count relative mr-10 w-160"
                :disabled="readonly"
                :options="exerciseIntensityConfig.typeConfig.options"
              >
              </Select>

              <template v-if="exercise.intensityCount[exercise.intensityTypeName].type !== 0">
                <Cascader
                  v-model="exercise.intensityCount[exercise.intensityTypeName].hardLevelValue"
                  :format-label="formatgradeLevel"
                  :options="gradeLevelOptions"
                  class="pl-10 intensity-count w-160 relative"
                  :disabled="readonly"
                >
                </Cascader>
                <span class="text-text-3 ml-10">{{ displayHardLevelValue }}</span>
              </template>
            </div>
          </template>
        </FormItem>
      </Form>
    </div>
    <template #footer>
      <div class="flex flex-row justify-between">
        <div class="flex flex-row justify-start items-center">
          <template v-if="hasEstimateInfo">
            <div class="text-white">
              <span class="mx-5 text-text-3">{{ $t('R9012') }}</span>
              <template v-if="estimateInfo.pitch">
                <span class="font-bold">{{ estimateInfo.pitch }}</span>
                <span class="mx-5 text-text-3 text-12">{{ $t(trainingProgram.sportType === 7 ? 'H9095' : 'H9039') }}</span>
              </template>
              <template v-if="estimateInfo.duration">
                <span class="font-medium">{{ estimateInfo.duration }}</span>
                <span class="mx-5 text-text-3 text-12">min</span>
              </template>
              <template v-if="estimateInfo.distance">
                <span class="font-medium">{{ estimateInfo.distance }}</span>
                <span class="mx-5 text-text-3 text-12">{{ estimateInfo.distanceUnitName }}</span>
              </template>
              <template v-if="estimateInfo.trainingLoad">
                <span class="font-medium">{{ estimateInfo.trainingLoad }}</span>
                <span class="mx-5 text-text-3 text-12">TL</span>
              </template>
            </div>
            <div
              class="ml-10 text-14 font-medium flex flex-row justify-start text-center"
              v-if="showCurrentDaySum"
            >
              <div class="flex flex-row justify-start">
                <span class="estimate-item cti">{{ $t('SQ9005') }}</span>
                <span class="estimate-item cti mx-10">{{ estimateInfo.currentDaySum.planCti }}</span>
              </div>
              <div class="flex flex-row justify-start">
                <span class="estimate-item ati">{{ $t('SQ9006') }}</span>
                <span class="estimate-item ati mx-10">{{ estimateInfo.currentDaySum.planAti }}</span>
              </div>
              <div class="flex flex-row justify-start">
                <span class="estimate-item tired-rate">{{ $t('Y9081') }}</span>
                <span class="estimate-item tired-rate mx-10">
                  {{ Math.round(estimateInfo.currentDaySum.planTrainingLoadRatio * 100) + '%' }}
                </span>
              </div>
            </div>
          </template>
        </div>
        <div
          v-if="!readonly"
          class="w-260 shrink-0"
        >
          <Button
            @click="handleCancel"
            class="mr-16 min-w-120"
          >
            {{ $t('C1006') }}</Button
          >
          <Button
            @click="handleSave"
            :loading="saveLoading"
            :disabled="calculateLoading"
            type="primary min-w-120"
          >
            {{ $t('R1007') }}</Button
          >
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup>
import { ref, computed, nextTick, onMounted } from 'vue';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
import { userStore as userStoreRef } from '@client/store/userStore';
import Definition from '@client/config/definition';
import { useI18n } from 'vue-i18n';
import { initStore as initStoreRef } from '@client/store/initStore';
import { scheduleStore as scheduleStoreRef } from '@client/store/scheduleStore';
import { memberDataStore as memberDataStoreRef } from '@client/store/memberDataStore';
import { trainingProgramDefaultData, defaultExerciseConfigs } from '@client/components/programEdit/constants';
import { parseSportConfig } from '@client/components/programEdit/TrainingProgramSubItem/utils';
import { countRHr, countRHrRatio } from '@client/helper/hr';
import { sportCategoryConfigMap } from '@client/config/sport';
import { paceSKmToOther } from '@client/helper/pace';
import { speedKmhToOther, speedToKmh } from '@client/helper/speed';
import { s2ms, parseSeconds } from '@client/helper/day';
import { getStringByMaxBytes, getStringByte } from '@client/helper/string';
import { training } from '@client/api';
import { unit as mathjsUnit } from 'mathjs';
import { toComponentExercises, dealSavingData, dealExerciseData } from '@client/components/programEdit/utils';
import InputNumberRange from '@client/components/InputNumberRange/index.vue';
import InputNumberFixed from '@client/components/InputNumberFixed/index.vue';

import {
  Modal,
  Form,
  FormItem,
  Input,
  Button,
  Textarea,
  Divider,
  Select,
  Option,
  InputGroup,
  TimePicker,
  Message,
  Cascader
} from '@arco-design/web-vue';
import { watch } from 'vue';
import { getCalculateInfo } from './utils';
import * as corosSportConfig from '@coros/sport-config';
import { useSwimPoolLength, getSavePoolLength } from '../programEdit/hooks/useSwimPoolLength';
import SwimPoolLength from '../programEdit/components/SwimPoolLength/index.vue';
import { checkFirstExerciseTargetUnitIsYardOrMile } from '../programEdit/utils/swim';

const { getDisplayHardLevelValue, getGradeLevelOptions, hardLevelConvert, isIndoorClimbOrBoulderingTrainingSportType } =
  corosSportConfig.sport.climb;

/*************** 响应式数据 ***************/
const emits = defineEmits(['onSave', 'onCancel']);
const paceFormat = `mm'ss"`;
const props = defineProps({
  readonly: {
    type: Boolean,
    default: false
  },
  showModal: {
    type: Boolean,
    default: false
  },
  from: {
    type: String,
    default: 'schedule'
  },
  operateType: {
    type: String,
    default: 'add'
  },
  user: {
    type: Object,
    default: () => ({})
  },
  trainingProgram: {
    type: Object,
    default: () => {
      return {
        sportType: 1,
        name: '',
        overview: '',
        id: '',
        planId: '',
        exercises: [],
        entities: [],
        programs: []
      };
    }
  }
});
const saveLoading = ref(false);
const calculateLoading = ref(false);
const initStore = initStoreRef();
const memberDataStore = memberDataStoreRef();
const estimateInfo = ref({});

const currentModelValidState = computed(() => {
  if (props.user.hasOwnProperty('modelValidState')) {
    return !!props.user.modelValidState;
  }

  return userStore.sportDataSummary.modelValidState;
});

const exerciseTargetConfig = computed(() => {
  const { targetTypeName, exerciseTypeName } = exercise.value;
  const typeConfig = getSportConfig()[exerciseTypeName].target.typeConfig[targetTypeName];
  const defaultExerciseTargetConfig = {
    inputConfig: {
      max: 499.99,
      min: 0.1,
      precision: 2,
      step: 0.01,
      defaultValue: 1
    }
  };
  if (!typeConfig) return defaultExerciseTargetConfig;
  const targetCount = exercise.value.targetCount[targetTypeName];
  const { unit } = targetCount;
  const config = typeConfig.unitConfig[unit];
  return config || defaultExerciseTargetConfig;
});
const exerciseIntensityConfig = computed(() => {
  const { intensityCount, intensityTypeName } = exercise.value;
  const intensityConfig = intensityCount[intensityTypeName];
  const unit = intensityConfig.unit;
  return intensityTypeConfig.value.unitConfig[unit];
});
const isFirstZone = computed(() => {
  const { intensityTypeName } = exercise.value;
  if (intensityTypeName === 'notSet') {
    return true;
  }
  const intensityCount = exercise.value.intensityCount[intensityTypeName];
  const { unit, type } = intensityCount;
  if (!unit) return;
  const exerciseIntensityConfig = intensityTypeConfig.value.unitConfig[unit];
  const options = exerciseIntensityConfig.typeConfig.options;
  if (!options) {
    return false;
  }
  return options[0].type === type;
});
const isLastZone = computed(() => {
  const { intensityTypeName } = exercise.value;
  if (intensityTypeName === 'notSet') {
    return true;
  }
  const intensityCount = exercise.value.intensityCount[intensityTypeName];
  const { unit, type } = intensityCount;
  if (!unit) return;
  const exerciseIntensityConfig = intensityTypeConfig.value.unitConfig[unit];
  const options = exerciseIntensityConfig.typeConfig.options;
  if (!options) {
    return false;
  }
  return options[options.length - 1].type === type;
});
const isEdit = computed(() => {
  return props.operateType === 'edit';
});
const showCurrentDaySum = computed(() => {
  return currentModelValidState.value && estimateInfo.value.currentDaySum;
});
const hasEstimateInfo = computed(() => {
  if (
    !estimateInfo.value.pitch &&
    !estimateInfo.value.duration &&
    !estimateInfo.value.distance &&
    !estimateInfo.value.trainingLoad &&
    !showCurrentDaySum.value
  ) {
    return false;
  }
  return true;
});
const userStore = userStoreRef();
const userId = computed(() => userStore.userId);
const scheduleStore = scheduleStoreRef();
// const trainingProgram = ref({ sportType: 1, name: '', overview: '', id: '', planId: '', exercises: [] });
const exercise = ref({
  targetTypeName: '',
  intensityTypeName: '',
  intensityCount: ''
});
const intensityTypeConfig = ref({});
const paceIntensityZoneList = ref([]);
const swimmingZoneList = ref([]);
const exerciseDefinition = ref([]);
const targetOptions = ref([]);
const heartIntensityZoneList = ref([]);
const ftpIntensityZoneList = ref([]);
const powerIntensityZoneList = ref([]);
const intensityOptions = ref([]);
const sportCategoryName = ref([]);
const unitOptions = ref([]);
const intensityUnitOptions = ref([]);
const { t } = useI18n();

const {
  inited: initedSwimPoolLength,
  poolLengthType,
  poolLengthUnit,
  distanceOptions,
  convertDistanceValue,
  init: initSwimPoolLength,
  clear: clearSwimPool,
  checkAndAlertPoolLengthChange,
  alertSetDefaultPoolLength
} = useSwimPoolLength();

/*************** 逻辑处理 ***************/
watch(
  () => props.showModal,
  (val) => {
    const reset = props.operateType === 'add' ? true : false;
    if (val) handleOpen(reset);
    // 关闭弹窗，清除泳池长度等状态
    if (!val) {
      clearSwimPool();
    }
  }
);

let estimateTimeout;

watch(
  () => exercise,
  (val) => {
    if (val.value?.targetTypeName) {
      nextTick(() => {
        setTimeout(() => {
          getEstimate();
        });
      });
    }
  },
  {
    deep: true
  }
);
// ['run', 'trailRun', 'bike', 'swim']
const sportTypeOptions = [1, 5, 2, 3, 6, 7].map((type) => {
  return sportCategoryConfigMap[type];
});

const handleOpen = (reset) => {
  initData(reset);
};
const handleNameInputChange = (val) => {
  props.trainingProgram.name = val;
};
const handleOverviewInputChange = (val) => {
  props.trainingProgram.overview = val;
};

onMounted(() => {
  watch(poolLengthType, (newVal, oldVal) => {
    if (!props.showModal) {
      return;
    }
    getEstimate();
    checkAndAlertPoolLengthChange(oldVal, newVal);
  });

  // 泳池长度变了，选项变化了，重置一下
  watch(distanceOptions, (newVal) => {
    if (!initedSwimPoolLength.value || !props.showModal) return;

    nextTick(() => {
      if (newVal.length > 0) {
        const currentVal = exercise.value.targetCount.distance.value;
        const val = convertDistanceValue(currentVal);
        if (val !== currentVal) {
          exercise.value.targetCount.distance.value = val;
        }
      }
    });
  });
  // 泳池长度单位变了，保存的值也要变化
  watch(poolLengthUnit, (newVal) => {
    if (!initedSwimPoolLength.value || !props.showModal) return;

    const unitName = corosSportConfig.basic.getTargetUnitNameByType(newVal);
    if (unitName) {
      // changeTargetDistanceUnit 内部对游泳做了特殊处理
      changeTargetDistanceUnit(unitName);
    }
  });
});

const initData = (reset = false) => {
  const { id, sportType } = props.trainingProgram;

  if (!reset) {
    // 编辑运动
    const program = props.trainingProgram.programs[0];

    const { poolLengthUnit, poolLengthId, poolLength } = program;

    let swimPoolIsYard;
    if (sportType === 3) {
      // 旧数据才检查
      if (typeof poolLengthId === 'undefined') {
        swimPoolIsYard = checkFirstExerciseTargetUnitIsYardOrMile(program.exercises);
        alertSetDefaultPoolLength(swimPoolIsYard);
      }
      initSwimPoolLength(poolLengthId, poolLength, poolLengthUnit, props.readonly, swimPoolIsYard);
    }

    exerciseDefinition.value = [];
    let exerciseData = program.exercises[0] || {};
    const result = dealExerciseInfo(exerciseData, { swimPoolIsYard });
    const { intensityTypeName, exerciseTypeName } = result;

    exerciseData = Object.assign(exerciseData, result);

    const exerciseConfig = cloneDeep(result);
    let typeConfig = getSportConfig()[exerciseTypeName].intensity.typeConfig[intensityTypeName];
    if (Reflect.has(typeConfig, 'defaultIntensityCustom')) {
      typeConfig.defaultIntensityCustom = exerciseData.intensityCount[intensityTypeName].type;
    }
    exercise.value = exerciseData;
    handleIntensityTypeChange(intensityTypeName);
    // 补偿数据被重置为默认值
    exercise.value.intensityCount[intensityTypeName] = exerciseConfig.intensityCount[intensityTypeName];
    getExerciseList(sportType);
    getTargetOptions();
    getIntensityOptions();
    getEstimate();
  } else {
    if (sportType === 3) {
      initSwimPoolLength(undefined, undefined, undefined, props.readonly, /*isImperial*/ false);
    }
    // 默认展开
    exerciseDefinition.value = [];
    makeDefaultExerciseInfo();
    getTargetOptions();
    getIntensityOptions();
    getEstimate();
  }
};

const sportConfig = computed(() => {
  let unit = userStore.unit;
  console.log('props.trainingProgram.sportType', props.trainingProgram.sportType);
  const newConfig = parseSportConfig(props.trainingProgram.sportType, currentZoneData.value, t, unit, currentCriticalPower.value);
  return newConfig;
});
const getSportConfig = () => {
  let unit = userStore.unit;
  console.log('props.trainingProgram.sportType', props.trainingProgram.sportType);
  const newConfig = parseSportConfig(props.trainingProgram.sportType, currentZoneData.value, t, unit, currentCriticalPower.value);
  return newConfig;
};
const currentUnit = computed(() => {
  const defaultUnit = userStore.unit;
  return defaultUnit;
});
const handleTimeChange = (val) => {
  // 将时间str转为秒

  exercise.value.targetCount.time.value = parseSeconds(val, 'HH:mm:ss');
};

// 调用接口计算增加该训练组合后当天的统计数据
const getEstimate = () => {
  clearTimeout(estimateTimeout);
  const { happenDay } = scheduleStore.activeScheduleData;
  estimateTimeout = setTimeout(async () => {
    if (!props.showModal) {
      estimateInfo.value = {};
      return;
    }
    let data = getData();
    const program = data.programs[0];
    const entity = data.entities[0];
    entity.planId = program.planId;

    const today = Number(dayjs().format('YYYYMMDD'));

    if (['template', 'plan'].includes(props.from) || happenDay < today) {
      const mathInfo = await calculateProgram(program);
      const {
        planDistance: distance,
        distanceDisplayUnit,
        planDuration: duration,
        planPitch: pitch,
        planSets: sets,
        planTrainingLoad: trainingLoad
      } = mathInfo;
      estimateInfo.value = getCalculateInfo({
        distance,
        distanceDisplayUnit,
        duration,
        pitch,
        sets,
        trainingLoad,
        currentUnit: currentUnit.value,
        program
      });

      return;
    }

    training
      .api4ProgramEstimate({
        params: getUserParams(),
        data: {
          entity,
          program
        }
      })
      .then(({ data }) => {
        const { currentDaySum, distance, distanceDisplayUnit, duration, pitch, sets, trainingLoad } = data.value;

        estimateInfo.value = getCalculateInfo({
          currentDaySum,
          distance,
          distanceDisplayUnit,
          duration,
          pitch,
          sets,
          trainingLoad,
          currentUnit: currentUnit.value,
          program
        });
      });
  }, 500);
};
// 将接口返回的动作数据转化为页面需要的格式添加动作
const dealExerciseInfo = (data, { swimPoolIsYard } = {}) => {
  const exerciseData = cloneDeep(data);
  if (!exerciseData) {
    return;
  }
  let result = {};
  result = dealExerciseData(result, exerciseData, getSportConfig(), currentCriticalPower.value, currentZoneData.value, true, {
    climbConfig: getUserClimbConf(),
    poolLengthId: props.trainingProgram.programs[0].poolLengthId,
    swimPoolIsYard
  });
  return result;
};

const getTargetOptions = () => {
  targetOptions.value = getSportConfig().train.target.options;
};
const getIntensityOptions = () => {
  intensityOptions.value = getSportConfig().train.intensity.options;
};
const currentCriticalPower = computed(() => {
  const { teamViewMode, userData } = memberDataStore;
  if (teamViewMode && userData.criticalPower) {
    console.log(333, 'team user criticalPower');
    return userData.criticalPower;
  }

  return userStore.criticalPower;
});

const currentZoneData = computed(() => {
  const { teamViewMode, userData } = memberDataStore;
  if (teamViewMode && userData.zoneData) {
    // 团队模式
    // console.log(3331, 'team user zone data');
    return userData.zoneData;
  }
  // console.log(2221, 'login user zone data');
  return userStore.zoneData;
});
const changeSportCategory = (val) => {
  Modal.warning({
    title: t('C1001'),
    content: t('R4029'),
    okText: t('C1005'),
    cancelText: t('C1006'),
    titleAlign: 'start',
    hideCancel: false,
    modalClass: 'coros-modal-footer-right',
    onOk: () => {
      props.trainingProgram.sportType = val;
      initData(true);
    },
    onCancel: () => {
      // console.log(trainingProgram.value.sportType);
      // trainingProgram.value.sportType
    }
  });
};
const handleTargetTypeChange = (value) => {
  const { exerciseTypeName } = exercise.value;
  if (value === 'manualEnd') {
    return;
  }
  const typeConfig = getSportConfig()[exerciseTypeName].target.typeConfig[value];
  unitOptions.value = Object.keys(typeConfig.unitConfig).map((key) => {
    return {
      key,
      nameText: key
    };
  });
  const { defaultUnit } = typeConfig;
  const { defaultValue } = typeConfig.unitConfig[defaultUnit].inputConfig;

  exercise.value.targetCount[value].unit = typeConfig.defaultUnit;
  exercise.value.targetCount[value].value = defaultValue;
  // 重新计算
};
const makeDefaultExerciseInfo = () => {
  const { sportType } = props.trainingProgram;
  if (!sportType) {
    props.trainingProgram.sportType = 1;
  }
  getExerciseList(props.trainingProgram.sportType)
    .then(() => {
      exerciseDefinition.value.forEach((item, index) => {
        const exerciseTypeName = Definition.exerciseTypeName[item.exerciseType];
        if (item.defaultOrder === 0 || !['train'].includes(exerciseTypeName)) {
          return;
        }

        const data = toComponentExercises(
          item,
          exerciseDefinition.value,
          getSportConfig(),
          currentCriticalPower.value,
          currentZoneData.value,
          false,
          { climbConfig: getUserClimbConf() }
        );

        exercise.value = data;
        props.trainingProgram.name = t(data.name);
        props.trainingProgram.overview = '';
        exercise.value.targetTypeName = data.targetTypeName;
        // item.exercises = [data];

        // handleTargetTypeChange(data.targetTypeName);
        handleIntensityTypeChange(exercise.value.intensityTypeName);
      });
    })
    .catch((error) => {
      console.log(error);
    });
};

const getExerciseList = (sportType) => {
  if (![4, '4'].includes(sportType)) {
    return new Promise((resolve, reject) => {
      exerciseDefinition.value = cloneDeep(defaultExerciseConfigs[Definition.sportCategoryName[sportType]] || []);
      resolve();
    });
  }
  // Todo: 移除多余promise
  return new Promise((resolve, reject) => {
    training
      .api4ExerciseQuery({
        params: {
          teamId: props.teamId,
          userId: props.user?.userId,
          sportType
        }
      })
      .then(({ data }) => {
        const resData = data.value || [];
        resData.sort((a, b) => {
          return a.sortNo - b.sortNo;
        });
        exerciseDefinition.value = resData;
        resolve();
      });
  });
};
// 改变强度类型, 获取对应区间选项
const handleIntensityTypeChange = (selectedType) => {
  if (selectedType === 'notSet') {
    intensityTypeConfig.value.extendType = 'notSet';
    return;
  }

  let { intensityTypeName, exerciseTypeName, intensityCount } = exercise.value;
  let unitKey = intensityCount[intensityTypeName].unit;

  let typeConfig = getSportConfig()[exerciseTypeName].intensity.typeConfig[intensityTypeName];

  let { typeConfig: childTypeConfig, rangeConfig } = typeConfig.unitConfig[unitKey];
  childTypeConfig = childTypeConfig || rangeConfig;
  let { options, defaultValue } = childTypeConfig;
  const { defaultIntensityCustom, defaultUnit } = typeConfig;
  if (Reflect.has(typeConfig, 'defaultIntensityCustom')) {
    intensityCount[intensityTypeName].type = defaultIntensityCustom;
    intensityCount[intensityTypeName].unit = defaultUnit;
  }
  const { type, isIntensityPercent } = typeConfig;
  if (type === 'adjustedPace') {
    typeConfig.extendType = 'pace';
  } else {
    typeConfig.extendType = type;
  }
  intensityTypeConfig.value = typeConfig;
  exercise.value.isIntensityPercent = isIntensityPercent || false;

  const zoneType = defaultIntensityCustom;
  // 获取强度区间
  getZoneListOptions(cloneDeep(options));
  // 初始化切换一个区间, 计算区间值
  changeZone(zoneType);
};
const getZoneListOptions = (options) => {
  let { intensityTypeName } = exercise.value;
  const { type, unitConfig } = intensityTypeConfig.value;
  switch (type) {
    // 心率类
    case 'heart':
      // 过滤跟区间无关的
      if (!['rhr'].includes(intensityTypeName)) {
        getHeartIntensityZoneList(options);
      }
      break;
    // ftp
    case 'ftp':
      getFtpIntensityZoneList(options);
      break;
    // 速度类
    case 'pace':
      // 过滤跟区间无关的
      if (!['thresholdPace'].includes(intensityTypeName)) {
        getPaceZoneList(options);
      }
      break;
    // 速度类
    case 'adjustedPace':
      // 过滤跟区间无关的
      if (!['adjustedPace'].includes(intensityTypeName)) {
        getPaceZoneList(options);
      }
      break;
    case 'swimmingStyle':
      getSwimmingZoneList();
      break;
    case 'power':
      getPowerZoneList(options);
    case 'cadence':
      break;
    default:
      break;
  }
  // 获取配速单位选项
  intensityUnitOptions.value = Object.keys(unitConfig).map((key) => {
    return {
      key,
      nameText: key
    };
  });
};
// 修改泳姿为分解动作时，目标类型只能为距离
const changeSwimmingStyle = (val) => {
  // 6 是分解动作，这个时候目标只能选距离
  if (val === 6) {
    exercise.value.targetTypeName = 'distance';
  }
};
const changeZone = (zoneType) => {
  const { intensityTypeName } = exercise.value;
  const { type } = intensityTypeConfig.value;
  switch (type) {
    // 心率类
    case 'heart':
      // 过滤跟区间无关的
      if (!['rhr'].includes(intensityTypeName)) {
        changeHrZone(zoneType);
      }
      break;
    // 心率类
    case 'ftp':
      changeFtpZone(zoneType);
      break;
    // 速度类
    case 'pace':
      // 过滤跟区间无关的
      if (!['thresholdPace'].includes(intensityTypeName)) {
        changePaceZone(zoneType);
      }
      break;
    // 速度类
    case 'adjustedPace':
      // 过滤跟区间无关的
      if (!['adjustedPace'].includes(intensityTypeName)) {
        changePaceZone(zoneType);
      }
      break;
    case 'power':

    case 'cadence':
      break;
    default:
      break;
  }
};
// 变更心率值区间
const changeHrZone = (zoneType) => {
  const { intensityTypeName } = exercise.value;
  const count = exercise.value.intensityCount[intensityTypeName];
  const options = heartIntensityZoneList.value;
  const rangeInfo = getZoneFromOptions(options, zoneType);
  count.range = rangeInfo.range;
  count.ratioRange = rangeInfo.ratioRange;
};
const changeFtpZone = (zoneType) => {
  const { intensityTypeName } = exercise.value;
  const count = exercise.value.intensityCount[intensityTypeName];
  const options = ftpIntensityZoneList.value;
  const rangeInfo = getZoneFromOptions(options, zoneType);
  count.range = rangeInfo.range;
  count.ratioRange = rangeInfo.ratioRange;
};
const changePaceZone = (zoneType) => {
  const { intensityTypeName } = exercise.value;
  const count = exercise.value.intensityCount[intensityTypeName];
  const options = paceIntensityZoneList.value;
  const rangeInfo = getZoneFromOptions(options, zoneType);
  count.range = rangeInfo.range;
  count.ratioRange = rangeInfo.ratioRange;
};
// 修改心率比值
const changeHrRatioRange = (val) => {
  const { intensityCount: intensity, intensityTypeName } = exercise.value;
  const { hrType } = intensityTypeConfig.value;
  const intensityCount = intensity[intensityTypeName];
  const userHr = currentZoneData.value[hrType] || 0;
  const isRHr = hrType === 'rhr';

  exercise.value.isIntensityPercent = true;
  intensityCount.type = 0; // 切换为自定义选项

  const [ratio0, ratio1] = val;
  const { rhr, maxHr } = currentZoneData.value;

  let range;
  if (isRHr) {
    range = [countRHr(rhr, maxHr, ratio0), countRHr(rhr, maxHr, ratio1)];
  } else {
    range = [(userHr * ratio0) / 100, (userHr * ratio1) / 100];
  }
  const [_range0, _range1] = range;
  intensityCount.range = [Math.round(_range0), Math.round(_range1)];
  intensityCount.ratioRange = val;
};
// 修改ftp比值
const changeFtpRatioRange = (val) => {
  const { intensityCount: intensity, intensityTypeName } = exercise.value;
  const intensityCount = intensity[intensityTypeName];
  const ftp = currentZoneData.value.ftp || 0;

  intensityCount.type = 0; // 切换为自定义选项

  const [ratio0, ratio1] = val;

  // %ftp对应的绝对功率计算公式为=百分比*FTP值
  const range = [Math.round((ratio0 / 100) * ftp), Math.round((ratio1 / 100) * ftp)];

  intensityCount.range = range;
  intensityCount.ratioRange = val;
};
// 修改心率绝对值
const changeHrRange = (val) => {
  const { intensityCount: intensity, intensityTypeName } = exercise.value;
  const { hrType } = intensityTypeConfig.value;
  const intensityCount = intensity[intensityTypeName];
  const userHr = currentZoneData.value[hrType] || 0;
  const isRHr = hrType === 'rhr';

  exercise.value.isIntensityPercent = false;
  intensityCount.type = 0; // 切换为自定义选项

  const [range0, range1] = val;
  const { rhr, maxHr } = currentZoneData.value;

  let ratioRange;

  if (isRHr) {
    ratioRange = [countRHrRatio(userHr, maxHr, range0), countRHrRatio(userHr, maxHr, range1)];
  } else {
    ratioRange = [(range0 / userHr) * 100, (range1 / userHr) * 100];
  }
  // const [_range0, _range1] = range;
  intensityCount.range = val;
  intensityCount.ratioRange = ratioRange;
};
// 修改配速比值
const changePaceRatioRange = (val) => {
  const { intensityTypeName, intensityCount: intensity } = exercise.value;
  const intensityCount = intensity[intensityTypeName];
  const { unit } = intensityCount;

  const ltsp = paceSKmToOther(unit, currentZoneData.value.ltsp || 0, 6);

  exercise.value.isIntensityPercent = true;
  const [ratio0, ratio1] = val;

  intensityCount.type = 0;

  const [range0, range1] = [Math.round(ltsp / (ratio0 / 100)), Math.round(ltsp / (ratio1 / 100))];

  intensityCount.range = [range0, range1];
  intensityCount.ratioRange = val;
};
// 修改配速绝对值
const changePaceRange = (val) => {
  const { intensityCount: intensityCounts, intensityTypeName } = exercise.value;
  const intensityCount = intensityCounts[intensityTypeName];
  const ltsp = paceSKmToOther(intensityCount.unit, currentZoneData.value.ltsp, 6);
  let [rangeText0, rangeText1] = val;

  exercise.value.isIntensityPercent = false;
  intensityCount.type = 0;
  const range0 = parseSeconds(rangeText0, `mm'ss"`);
  const range1 = parseSeconds(rangeText1, `mm'ss"`);
  intensityCount.range = [range0, range1];
  intensityCount.ratioRange = [Math.round((ltsp / range1) * 100), Math.round((ltsp / range0) * 100)];
};
// 修改配速/速度绝对值
const changeSpeedRange = (val) => {
  const { intensityCount: intensityCounts, intensityTypeName } = exercise.value;
  const intensityCount = intensityCounts[intensityTypeName];
  const ltsp = paceSKmToOther(intensityCount.unit, currentZoneData.value.ltsp, 6);

  const [range0, range1] = val;
  exercise.value.isIntensityPercent = false;
  intensityCount.type = 0;

  const ratioRange = [Math.round((ltsp / range1) * 100), Math.round((ltsp / range0) * 100)];
  intensityCount.range = val;
  intensityCount.ratioRange = ratioRange;
};
// 修改功率区间
const changePowerRange = (val) => {
  const { intensityCount: intensityCounts, intensityTypeName } = exercise.value;
  const criticalPower = currentCriticalPower.value;
  const intensityCount = intensityCounts[intensityTypeName];
  intensityCount.type = 0; // 自定义

  if (criticalPower) {
    const [range0, range1] = val;
    const ratioRange = [Math.round((range0 / criticalPower) * 100), Math.round((range1 / criticalPower) * 100)];
    intensityCount.range = val;
    intensityCount.ratioRange = ratioRange;
  }
};
// 修改步频
const changeCadenceRange = (val) => {
  const { intensityCount: intensityCounts, intensityTypeName } = exercise.value;
  const intensityCount = intensityCounts[intensityTypeName];
  intensityCount.type = 0; // 自定义
  intensityCount.range = val;
};
const getHeartIntensityZoneList = (_options = []) => {
  if (_options.length) {
    _options = _options.concat({
      type: 0,
      name: 'S4238',
      nameText: t('S4238')
    });
  }

  heartIntensityZoneList.value = _options;
};
const getFtpIntensityZoneList = (_options = []) => {
  ftpIntensityZoneList.value = _options;
};
const getPowerZoneList = (_options = []) => {
  if (_options.length) {
    _options = _options.concat({
      type: 0,
      name: 'S4238',
      nameText: t('S4238')
    });
  }
  powerIntensityZoneList.value = _options;
};
const getPaceZoneList = () => {
  const { intensityTypeName } = exercise.value;
  const intensityCount = exercise.value.intensityCount[intensityTypeName];
  const unit = intensityCount.unit;
  const exerciseIntensityConfig = intensityTypeConfig.value.unitConfig[unit];
  let options = cloneDeep(exerciseIntensityConfig.typeConfig.options);
  if (options.length) {
    options = options.concat({
      type: 0,
      name: 'S4238',
      nameText: t('S4238')
    });
  }

  paceIntensityZoneList.value = options;
};
const getSwimmingZoneList = () => {
  const { intensityTypeName } = exercise.value;
  const intensityCount = exercise.value.intensityCount[intensityTypeName];
  const unit = intensityCount.unit;
  const exerciseIntensityConfig = intensityTypeConfig.value.unitConfig[unit];
  let options = cloneDeep(exerciseIntensityConfig.typeConfig.options);
  swimmingZoneList.value = options;
};
// 从传入的数组中找出对应类型的区间
const getZoneFromOptions = (options, zoneType) => {
  let fistZone = null;
  let zone = null;
  options.forEach((item) => {
    if (!fistZone && item.type) {
      fistZone = item;
    }
    if (item.type === zoneType) {
      zone = item;
    }
  });
  let targetZone = null;
  if (zone && zoneType) {
    targetZone = zone;
  } else {
    targetZone = fistZone;
  }
  let { range, ratioRange } = targetZone;
  const [range0, range1] = range;
  const [ratio0, ratio1] = ratioRange;

  range = [Math.round(range0), Math.round(range1)];
  ratioRange = [Math.round(ratio0), Math.round(ratio1)];
  return {
    range,
    ratioRange
  };
};
const getData = () => {
  let data;
  if (isEdit.value) {
    data = makeSavingData();
  } else {
    data = makeAddingData();
  }
  // 泳池长度
  data.programs[0].poolLengthId = poolLengthType.value;
  data.programs[0].poolLength = getSavePoolLength();
  data.programs[0].poolLengthUnit = poolLengthUnit.value;
  // console.log(`🔔 program`, data.programs[0]);
  return data;
};
// 保存日程修改数据
const handleSave = async (e) => {
  let data = getData();

  // return;
  if (saveLoading.value) return;
  saveLoading.value = true;
  const { happenDay } = scheduleStore.activeScheduleData;
  try {
    const program = data.programs[0];
    const mathInfo = await calculateProgram(program);
    const { planDistance, planDuration, planTrainingLoad, planSets, planPitch, exerciseBarChart, distanceDisplayUnit } = mathInfo;
    program.distance = planDistance;
    program.duration = planDuration;
    program.trainingLoad = planTrainingLoad;
    program.sets = planSets;
    program.pitch = planPitch;
    program.totalSets = planSets;
    if (exerciseBarChart) {
      program.exerciseBarChart = exerciseBarChart;
      data.entities[0].exerciseBarChart = exerciseBarChart;
    }
    program.distanceDisplayUnit = distanceDisplayUnit;
    data.programs[0] = program;
  } catch (err) {
    console.log(err);
    Message.error('error');
  }
  const { operateType } = props;
  if (scheduleStore.site === 'plan') {
    // 当为计划且
    // scheduleStore.updateMaxIdInPlan();
    saveLoading.value = false;
    emits('onSave', { data, operateType });
    // 关闭弹窗
    return;
  }
  // return;
  const params = getUserParams();
  training
    .api4UpdateSchedule({
      params,
      data
    })
    .then((res) => {
      saveLoading.value = false;
      Message.success(t('R4030'));
      emits('onSave', happenDay);
    })
    .catch((err) => {
      console.error(err);
      saveLoading.value = false;
    });
};
// 调用接口计算program的数值
const calculateProgram = (data) => {
  // 未登录
  if (!initStore.CPL_Token) {
    // console.log(`🔔 calculateProgram`, data);
    return new Promise((resolve) => {
      resolve({
        planDistance: data.distance,
        planDuration: data.duration,
        planSets: data.totalSets,
        // TODO: todo_climb 这里是否是 pitch?
        planPitch: data.pitch,
        planTrainingLoad: data.trainingLoad,
        distanceDisplayUnit: data.distanceDisplayUnit
      });
    });
  }
  calculateLoading.value = true;
  return new Promise((resolve, reject) => {
    training
      .api4CalculateTrainingProgram({
        params: getUserParams(),
        data
      })
      .then(({ data }) => {
        calculateLoading.value = false;
        resolve(data.value);
      });
  });
};
const getUserParams = () => {
  const { teamViewMode, userData } = memberDataStore;
  if (['template'].includes(props.from)) {
    return {};
  }
  if (teamViewMode && userData) {
    const { userId, teamId } = userData;
    return {
      userId,
      teamId
    };
  } else {
    return {};
  }
};

const makeAddingData = () => {
  const { activeScheduleData, maxIdInPlan } = scheduleStore;
  const { sportType, name, overview } = props.trainingProgram;
  const { happenDay, dayNo = 0 } = activeScheduleData;
  const _exerciseDefinition = cloneDeep(trainingProgramDefaultData[Definition.sportCategoryName[sportType]]);
  const { pbVersion } = _exerciseDefinition;
  const idInPlan = maxIdInPlan + 1;

  const programDefine = {
    // 关联的训练方案在训练计划中的id
    idInPlan,
    // 方案名称
    name,
    // 方案所属运动类，1：跑步类，2：骑行类，3：游泳类，4：力量类
    sportType,
    // 子运动类型
    subType: 0,
    // 动作总组数
    totalSets: 1,
    sets: 1,
    // originId,
    // 动作数量
    exerciseNum: '',
    // 目标类型, 1：手动结束、2：时间、3：次数、4：心率、5：距离、6：负荷
    targetType: '',
    // 目标值，时间(s)/距离(m)/次数/功率(w)
    targetValue: '',
    // 方案版本号
    version: 0,
    // 是否是精简方案，true-精简方案，false-不是，精简精简方案有且只有一个动作
    simple: true,
    // 方案动作
    exercises: [cloneDeep(exercise.value)],
    // 数据来源, 0:官方的 1:用户自定义
    access: 1,
    // 原作者id,与origin_id搭配使用，author_id表示方案最初作者的id
    // authorId: '0',
    // 本方案类型：0：普通方案，1：官方认证精华方案，2：官方认证精华方案被分享后修改
    essence: 0,
    // 预估时间
    estimatedTime: 0,
    // 原始方案类型：0：普通方案，1：官方认证精华方案，2：官方认证精华方案被分享后修改
    // 表示本方案是引用的别人分享的方案
    originEssence: 0,
    // 方案概述
    overview,
    // 0:默认(通过方案功能添加) 1:快捷(在训练计划模块添加的)
    type: 0,
    // 公英制。0：表示公制，1：表示英制，默认是公制
    unit: currentUnit.value,
    pbVersion
  };
  const program = dealSavingData(
    programDefine,
    currentZoneData.value,
    exerciseDefinition.value,
    getSportConfig(),
    currentUnit.value,
    currentCriticalPower.value
  );

  const exerciseItem = program.exercises[0];
  if (isIndoorClimbOrBoulderingTrainingSportType(sportType)) {
    exerciseItem.restType = 0;
  } else {
    exerciseItem.restType = 3;
  }
  exerciseItem.restValue = 0;
  // 新建数据
  const result = {
    entities: [
      {
        // 发生的日期
        happenDay,
        // 与训练方案相关联的id
        idInPlan,
        // 每一天中训练的排序
        sortNo: 0,
        dayNo,
        sortNoInPlan: 0,
        sortNoInSchedule: 0
      }
    ],
    programs: [program],
    pbVersion,
    versionObjects: [
      {
        // program中的idInPlan
        id: idInPlan,
        // 1：新增、2：修改、3：删除
        status: 1
      }
    ]
  };

  // if (that.site === 'plan') {
  //   entity.dayNo = that.$helpers.isNoValue(entity.dayNo) ? that.dayNo : entity.dayNo;

  //   entity.happenDay = entity.happenDay || that.happenDay;
  //   entity.sortNoInSchedule = entity.sortNoInSchedule || that.sortNoInSchedule;
  // }

  return result;
};
const makeSavingData = () => {
  const { name, entities, programs, overview, sportType } = cloneDeep(props.trainingProgram);
  const _program = programs[0];
  const entitie = entities[0];
  _program.sportType = sportType;
  const { planId, idInPlan, exercises = [] } = _program;
  const { planProgramId } = entitie;
  const _exercise = cloneDeep(exercise.value);
  _program.exercises = [_exercise];
  const result = {
    entities: [entitie],
    programs: [_program],
    versionObjects: [
      {
        // program中的idInPlan
        id: idInPlan,
        // 1：新增、2：修改、3：删除
        status: 2,
        planProgramId,
        planId
      }
    ],
    pbVersion: initStore.PB_VERSION
  };

  const program = dealSavingData(
    result.programs[0],
    currentZoneData.value,
    exerciseDefinition.value,
    getSportConfig(),
    currentUnit.value,
    currentCriticalPower.value
  );

  // 修改数据
  program.sets = 1;
  program.overview = overview;
  program.name = name;
  program.pbVersion = initStore.PB_VERSION;
  const exerciseItem = program.exercises[0];
  result.pbVersion = program.pbVersion;
  if (isIndoorClimbOrBoulderingTrainingSportType(sportType)) {
    exerciseItem.restType = 0;
  } else {
    exerciseItem.restType = 3;
  }
  exerciseItem.restValue = 0;

  result.programs[0] = program;

  return result;
};
const handleCancel = () => {
  emits('onCancel');
};
const changeIntensityPaceUnit = (unit) => {
  const { intensityTypeName, intensityCount: intensityCountType } = exercise.value;
  const intensityCount = intensityCountType[intensityTypeName];
  const { type, ratioRange } = intensityCount;

  let { ltsp } = currentZoneData.value;
  intensityCount.unit = unit;

  // 没有选择类型，则数据需要手动转换
  if (['', '0', 0, false].includes(type)) {
    ltsp = paceSKmToOther(unit, ltsp, 6);

    let [ratio0, ratio1] = ratioRange;
    ratio0 = ratio0 === 0 ? 100 : ratio0;
    ratio1 = ratio1 === 0 ? 100 : ratio1;
    const value0 = Math.round((ltsp * 100) / ratio0);
    const value1 = Math.round((ltsp * 100) / ratio1);
    intensityCount.range = [value1, value0];
  } else {
    changePaceZone(type);
  }
};
const changeTargetDistanceUnit = (unit) => {
  // 切换距离单位
  const { targetTypeName, exerciseTypeName } = exercise.value;

  const typeConfig = getSportConfig()[exerciseTypeName].target.typeConfig[targetTypeName];
  const targetCount = exercise.value.targetCount[targetTypeName];

  // 游泳、目标=距离时，不转换数值
  if (props.trainingProgram.sportType === 3) {
    if (targetTypeName === 'distance') {
      targetCount.unit = unit;
    }
    return;
  }

  const { value, unit: oldUnit } = targetCount;
  const precision = typeConfig.unitConfig?.[unit]?.inputConfig?.precision || 0;
  // 赋予新的单位
  targetCount.unit = unit;
  const distance = mathjsUnit(value, oldUnit).toNumber(unit).toFixed(precision);
  let val = Number(distance);
  const max = exerciseTargetConfig.value.inputConfig.max;
  if (val > max) {
    val = max;
  }
  targetCount.value = Number(val);
};
const changeIntensitySpeedUnit = (unit) => {
  const { intensityTypeName, intensityCount: intensityCountType, exerciseTypeName } = exercise.value;
  const intensityCount = intensityCountType[intensityTypeName];
  const { range, unit: oldUnit } = intensityCount;
  // 先根据旧的单位将数值统一转换为m/h为单位的数值
  const [range0, range1] = range;
  const baseRange0 = speedToKmh(oldUnit, range0, 6);
  const baseRange1 = speedToKmh(oldUnit, range1, 6);

  const typeConfig = getSportConfig()[exerciseTypeName].intensity.typeConfig[intensityTypeName];

  const precision = typeConfig.unitConfig?.[unit]?.rangeConfig?.precision || 0;
  const resultRange = [speedKmhToOther(unit, baseRange0, precision), speedKmhToOther(unit, baseRange1, precision)];
  // 赋予新的单位
  intensityCount.unit = unit;
  intensityCount.range = resultRange;
};

// 更改难度系统，要换算难度等级
function changeGradeSystem(val) {
  const { type: oldVal, hardLevelValue } = exercise.value.intensityCount.gradeSystem;
  if (oldVal !== val) {
    const [levelType, level] = hardLevelValue.split('-').map((str) => parseInt(str, 10));
    // levelType=1 是相对等级，不用处理
    if (levelType === 2) {
      // 这里要在 intensityCount.gradeSystem.type 更新后才处理，这里用 nextTick 不行
      setTimeout(() => {
        const convertedLevel = hardLevelConvert(oldVal, val, level);
        exercise.value.intensityCount.gradeSystem.hardLevelValue = `2-${convertedLevel}`;
      });
    }
  }
  exercise.value.intensityCount.gradeSystem.type = val;
}
function formatgradeLevel(options) {
  return options[1].label;
}
// hardLevelValue 是前端虚拟的字段，处理同一个下拉菜单对应了两个字段的值的问题
// 两个字段是：intensityValue 和 onsightGradeOffset
const gradeLevelOptions = computed(() => {
  const gradingSystem = exercise.value.intensityCount.gradeSystem.type;

  return getGradeLevelOptions(props.trainingProgram.sportType, gradingSystem);
});
// 显示难度等级
const displayHardLevelValue = computed(() => {
  const { intensityCount, intensityTypeName } = exercise.value;

  const climbConfig = getUserClimbConf();
  if (!climbConfig) return '';
  return getDisplayHardLevelValue({
    climbConfig,
    exerciseGradeSystem: intensityCount.gradeSystem.type,
    sportType: props.trainingProgram.sportType,
    val: intensityCount[intensityTypeName].hardLevelValue
  });
});

function getUserClimbConf() {
  const { teamViewMode, userData } = memberDataStore;
  const climbConfig = teamViewMode ? userData.climbConfig : userStore.climbConfig;
  return climbConfig;
}
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';
@import '@client/styles/theme-dark.css';
@import './reset.scss';
.coros-training-edit-modal {
  .plan-edit-intensity {
    .program-distance-input {
      width: px2rem144(70);
      flex: 0 0 px2rem144(70);
    }
  }
  .last-zone-value .arco-input {
    @apply text-white;
    -webkit-text-fill-color: #fff;
  }
  .program-distance-input-suffix {
    width: px2rem144(120);
  }
  .plan-edit-target {
    .program-time-inputgroup {
      width: px2rem144(160);
      flex: 0 0 px2rem144(160);
      .arco-picker-suffix {
        border-left: 1px solid rgba(255, 255, 255, 0.1);
        @apply pl-10;
      }
    }
    .unit-append,
    .hms-editor > .append {
      color: rgba(255, 255, 255, 0.4);
      // background-color: #232b40;
    }
  }
  .program-distance-inputgroup {
    width: px2rem144(160);
    flex: 0 0 px2rem144(160);
  }
  .program-distance-inputgroup {
    .program-distance-input {
      border-right-color: rgba(255, 255, 255, 0.1);
    }
  }
}
.estimate-item {
  &.ati {
    color: var(--ati-color);
  }

  &.cti {
    color: var(--cti-color);
  }

  &.tired-rate {
    color: var(--tired-rate-color);
  }
}
.coros-training-edit-modal {
  width: px2rem144(896);
  .arco-modal-footer {
    background-color: #323d5a;
    border-top: none;
  }
}
.noborder {
  .arco-input-wrapper {
    @apply border-none;
  }
  &.arco-select-view-single {
    @apply border-none;
  }
}
.coros-training-edit-textarea {
  width: px2rem144(420);
  height: px2rem144(116);
}
.coros-training-edit-button {
  width: px2rem144(120);
}
.program-edit-option-icon {
  width: px2rem144(16);
}

.plan-edit-range-input {
  .arco-input-disabled {
    @apply border-dark-60;
  }
}
.program-distance-input-label {
  width: px2rem144(52);
}
</style>
